import FooterRedirect from "./component/FooterRedirect";
import Headroom from "headroom.js";
import ImageSlider from "./component/ImageSlider";
import HeroSlider from "./component/HeroSlider";
import NewListPage from "./component/ListPage/ListPage";
import ListPage from "./component/ListPage";
import Navigation from "./component/Navigation";
import NewsListing from "./component/NewsListing";
import PaperJournal from "./component/PaperJournal";
import PaperJournalToggle from "./component/PaperJournalToggle";
import Polyfills from "./polyfills";
import ProductCards from "./component/ProductCards";
import ReportListBlockView from "./component/ReportListBlock";
import Resellers from "./component/Resellers";
import ToggleButton from "./component/ToggleButton";
import ToggleMenu from "./component/ToggleMenu";
import AutoCompleteView from "./component/AutoComplete";
import AutoCompleteHeaderView from "./component/AutoCompleteHeader";
import SearchItemsList from "./component/SearchItemsList";

// import FooterOptions from "./component/FooterOptions";

(function () {
  if (typeof NodeList.prototype.forEach === "function") return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

(function () {
  var JS = {
    common: {
      init: function () {
        console.log("common init");
      },
      finalize: function () {
        console.log("common finalize");

        document.querySelectorAll(".js-toggle-menu").forEach((element) => {
          new ToggleMenu(element);
        });

        document.querySelectorAll(".js-toggle-button").forEach((element) => {
          new ToggleButton(element);
        });

        document.querySelectorAll(".image.js-glide").forEach((element) => {
          new ImageSlider(element);
        });

        document.querySelectorAll(".hero.js-glide").forEach((element) => {
            new HeroSlider(element);
            console.log(element.dataset.autostart);
        });

        document
          .querySelectorAll(".js-paperjournal-toggle")
          .forEach((element) => {
            new PaperJournalToggle(element);
          });

        // document.querySelectorAll(".js-footer-options").forEach(element => {
        //   new FooterOptions(element);
        // });

        document.querySelectorAll(".js-footer-redirect").forEach((element) => {
          new FooterRedirect(element);
        });

        document.querySelectorAll(".js-product-cards").forEach((element) => {
          new ProductCards(element);
        });

        document.querySelectorAll(".js-navigation").forEach((element) => {
          new Navigation(element);
        });

        document.querySelectorAll(".paper-journal").forEach((element) => {
          new PaperJournal(element);
        });

        document.querySelectorAll(".news-listing").forEach((element) => {
          new NewsListing(element);
        });

        document.querySelectorAll(".js-list-page").forEach((element) => {
          new ListPage(element);
        });

        document.querySelectorAll(".js-newlist-page").forEach((element) => {
            new NewListPage(element);
        });

        document.querySelectorAll(".resellers").forEach((element) => {
          new Resellers(element);
        });

        document
          .querySelectorAll(".js-report-list-block")
          .forEach((element) => {
            new ReportListBlockView(element);
          });

        document
            .querySelectorAll("#js-autocomplete-root")
            .forEach((element) => {
                new AutoCompleteView(element);
            });

        document
            .querySelectorAll("#js-autocomplete-header-root")
            .forEach((element) => {
                new AutoCompleteHeaderView(element);
            });

        //element closest polyfill for IE
        if (!Element.prototype.matches) {
          Element.prototype.matches =
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
        }

        if (!Element.prototype.closest) {
          Element.prototype.closest = function (s) {
            var el = this;

            do {
              if (Element.prototype.matches.call(el, s)) return el;
              el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
          };
        }
        var navbar = document.querySelector(".navbar");
        if (navbar) {
          new Headroom(navbar, {
            classes: {
              initial: "navbar",
              pinned: "navbar--pinned",
              unpinned: "navbar--unpinned",
              top: "navbar--top",
              notTop: "navbar--not-top",
              bottom: "navbar--bottom",
              notBottom: "navbar--not-bottom",
            },
          }).init();
        }

        var breadcrumbQuery = document.querySelector(".breadcrumb");
        if (breadcrumbQuery) {
          new Headroom(document.querySelector(".breadcrumb"), {
            classes: {
              initial: "breadcrumb",
              pinned: "pinned",
              unpinned: "unpinned",
              top: "top",
              notTop: "not-top",
              bottom: "bottom",
              notBottom: "not-bottom",
            },
          }).init();
        }
      },
    },
    // StartPage
    StartPage: {
      init: function () {
        console.log("StartPage init");
      },
      finalize: function () {
        console.log("StartPage finalize");
      },
    },
  };

  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = JS;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      const classList = [...document.body.classList];
      classList.map((className) => {
        UTIL.fire(className);
        UTIL.fire(className, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  var Accordion = {
      setupAccordion: function () {

          var elems = document.querySelectorAll('.collapsible');
          //var instances = M.Collapsible.init(elems);

          var elems = document.querySelectorAll('.collapsible.expandable');
          var oneOpen = document.querySelectorAll('.oneOpen').length > 0;
          var elemDivs = document.querySelectorAll('.collapsible.expandable .collapsible-header');

          if (elems !== null) {

              elems.forEach(function (elem) {
                  elem.classList.remove("no-js");
              });

              var elemListItems = document.querySelectorAll('.collapsible.expandable li');

              if (elemListItems !== null) {
                  elemListItems.forEach(function (listItem) {
                      var theDiv = listItem.querySelector(".collapsible-header");

                      listItem.addEventListener("DOMContentLoaded", function () {

                          // Preopen preselected sections
                          if (listItem.classList.contains('active')) {
                              theDiv.setAttribute('aria-expanded', 'true');
                          }
                          else {
                              theDiv.setAttribute('aria-expanded', 'false');
                          }
                      });

                      theDiv.addEventListener('click', function () {

                          if (!oneOpen) {
                              // Remove all active classes, only used to preopen sections on load
                              elemListItems.forEach(function (li) {
                                  li.classList.remove('active');
                              });
                          }

                          let isActive = listItem.classList.contains('active');
                          let aria = theDiv.getAttribute('aria-expanded');

                          // Reset all aria-expanded on click
                          if (oneOpen > 0 && elemDivs !== null) {
                              elemDivs.forEach(function (elemDiv) {
                                  elemDiv.setAttribute('aria-expanded', 'false');
                              });
                          }

                          if (aria == 'true' && !isActive) {
                              theDiv.setAttribute('aria-expanded', 'false');
                          }
                          else {
                              theDiv.setAttribute('aria-expanded', 'true');
                          }

                          // Remove all active classes, only used to preopen sections on load
                          elemListItems.forEach(function (li) {
                              li.classList.remove('active');
                          });
                      });
                  });
              }
          }
      }
  };

    UTIL.loadEvents();
    Accordion.setupAccordion();

})();
